// extracted by mini-css-extract-plugin
export default {"baseMode-bg":"#1976d2","baseMode-dark":"#000","pardisan-primary":"#1976d2","pardisan-primary-dark":"#1976d2","pardisan-primary-light":"#1976d2","pardisan-primary-contrast":"#fff"};